import { schema } from 'normalizr'

export const Dashboard = new schema.Entity(
  'dashboards',
  {},
  {
    idAttribute: '_id',
  },
)

export const Alert = new schema.Entity(
  'alerts',
  {},
  {
    idAttribute: 'id',
  },
)

// TODO: maybe make "status" a seperate entity and deal with history by making it an array
